export const LANGUAGE_UZ = 'uz';
export const LANGUAGE_RU = 'ru';
export const DEFAULT_LANGUAGE = LANGUAGE_UZ;